import React from 'react';
import { Form, Input } from 'antd';
import { filedNames } from '../../constants';

const TitleField = ({ form, initialValue }) => {
  const { getFieldDecorator } = form;

  return (
    <Form.Item label="Заголовок" colon={false}>
      {getFieldDecorator(filedNames.title, {
        initialValue,
        rules: [
          {
            required: true,
            whitespace: true,
            message: 'Укажите заголовок',
          },
        ],
      })(<Input />)}
    </Form.Item>
  );
};

export default TitleField;
